import { Component, OnInit, OnDestroy } from '@angular/core';
import { Event, Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { CredentialBuildingService } from './providers/credential-building.service';
import { Horse_show_series } from '../../models/horse_show_series';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { credentialing_workflow_steps } from './credentialing-workflow-steps';


@Component({
  standalone: false,
  selector: 'app-credentialing',
  templateUrl: './credentialing.component.html',
styleUrls:  ['./credentialing.component.css']
})
export class CredentialingComponent implements OnInit {

  credentialing_workflow_steps = credentialing_workflow_steps;

  private _credentialBuildingSubscription: Subscription;

	horse_show_series: Horse_show_series = new Horse_show_series({});

	current_step: number = 0;

  constructor(private router: Router, private route: ActivatedRoute, private credentialBuildingService: CredentialBuildingService) { }

  ngOnInit() {
  	this._credentialBuildingSubscription = this.credentialBuildingService.horse_show_series$.subscribe(horse_show_series => {
  		this.horse_show_series = horse_show_series;
  	});

	this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0)
    });

  }

	handleSelectHorseShowSeries(){
		this.router.navigate(['credentialing/select-horse-show-series']);
	}

	handleReviewList(){
		this.router.navigate(['credentialing/review-list']);
	}

	handleSubmittedList(){
		this.router.navigate(['credentialing/receipt']);
	}


	handleBreadcrumbs(){
	    const ROUTE_DATA_BREADCRUMB: string = "current_step";

	    //subscribe to the NavigationEnd event
	    this.router.events.pipe(filter((event: Event) => event instanceof NavigationEnd)).subscribe(event => {
	      //set breadcrumbs
	      let root: ActivatedRoute = this.route.root;
	      let children: ActivatedRoute[] = this.route.children;
	      children.forEach(child => {

	        console.log(child);

	        if(child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)){
	          console.log(child.snapshot.data[ROUTE_DATA_BREADCRUMB]);
	          this.current_step = child.snapshot.data[ROUTE_DATA_BREADCRUMB];
	          return;
	        }
	      });

	    });
	  }

}
